import { Classes, Dialog, Spinner } from "@blueprintjs/core"
import { observer } from "mobx-react"
import { PlanrButton } from "modules/common/components/planr/button/Button"
import React, { useEffect } from "react"
import { FeedbackStoreType } from "../models/feedback-store"
import styles from "./Feedback.module.scss"
import { FeedbackBranches } from "./FeedbackBranches"
import { FeedbackThread } from "./FeedbackThread"

/** Чат обратной связи: сотруднику — его обращение, админу — ещё и список всех веток */
export const FeedbackDialog = observer(({ store, userId, onClose }: FeedbackDialogProps) => {
  useEffect(() => {
    store.open()
  }, [store])

  const loading = store.branchesLoading && !store.branchesLoaded

  return (
    <Dialog
      isOpen={true}
      onClose={onClose}
      title="Обратная связь"
      isCloseButtonShown={true}
      backdropClassName="standard"
      canOutsideClickClose={false}
      canEscapeKeyClose={true}
      enforceFocus={false}
      portalClassName={styles.portal}
      className={`figma-dialog ${styles.dialog} ${store.isAdmin ? styles.adminDialog : ""}`}
    >
      <div className={`${Classes.DIALOG_BODY} ${styles.body}`}>
        {loading && (
          <div className={styles.state}>
            <Spinner size={30} />
          </div>
        )}

        {!loading && store.branchesError && (
          // переписка живёт только в versionControl: без него показываем ошибку, а не пустую ленту
          <div className={styles.state}>
            <div className={styles.stateText}>{store.branchesError}</div>
            <PlanrButton type="secondary" size="small" icon="general-redo" onClick={() => store.open()}>
              Повторить
            </PlanrButton>
          </div>
        )}

        {!loading && !store.branchesError && store.branchesLoaded && (
          <div className={styles.layout}>
            {store.isAdmin && <FeedbackBranches store={store} userId={userId} />}
            <FeedbackThread store={store} userId={userId} />
          </div>
        )}
      </div>
    </Dialog>
  )
})

interface FeedbackDialogProps {
  store: FeedbackStoreType
  userId: string
  onClose: () => void
}
